import { useQuery } from '@tanstack/react-query';

import { addressByIdOptions } from '../data-provider';

export const useAddressById = (id?: string) =>
  useQuery({
    ...addressByIdOptions(id ?? ''),
  });
